import gd from 'ampersand-app'; // Pochemu udalili? Ot kuda vzyat esli udalili?
const FakePresence = new Proxy({}, {get(target, name) {
    return function() {
        // console.log('fake_presence', arguments);
        return true;
    }
}});

import EventsBus from 'src/core/gd/bus/events-bus';
import Attachments from 'core/gd/attachments';
import CompaniesCollection from 'src/core/gd-model/tree/companies-collection';

import LocalSettings from 'gd-local-settings';

import AccessControl from 'src/core/gd/access-control/access-control';
import Settings from 'src/core/gd/settings/global-settings';
import AppManager from './app-manager';
import TaskView from './task-view';
import NoteView from "./note-view";

import Polyfill from 'core/gd/polyfill/all';

import Skin, {SkinTheme} from 'core/gd/skin/skin';
import Api from './api';
import TaskTimers from "src/core/gd/task-timer/task-timers";
import ItemView, {ITEM_VIEW_TASK} from "core/gd/app-manager/item-view";
import ModelBus from "../../../src/core/gd/bus/model-bus";
import GlobalFields from "../../../src/core/gd/fields/fields"
import SharedNavigation from "./navigation"
import KeyboardShortcuts from "../../../src/core/gd/keyboard-shortcuts/keyboard-shortcuts";
import GDSession from "../../../src/core/gd-session/session"
import Modules from "../../../src/core/modules/modules"
import {Spaces} from "core/model2/space/spaces";
import Databases from "../../../src/core/model2/databases/databases"
import {createUI} from "../../../src/layout/ui/factory";
import {UIType} from "../../../src/layout/ui/@const";

// const debug = "{GD.SHARED-VIEW}"
const debug = false

gd.extend({

    spaces              : null,
    modules             : null,

    viewMode            : 'shared-view',
    isSharedView        : true,

    const               : require('core/gd/const'),
    router:              null,
    // skin: new SkinManager(),
    loader              : require('core/gd/loader'),
    utils               : require('core/gd/utils/utils'),
    format              : require('core/gd/utils/format'),
    datetime            : require('core/gd/utils/datetime-utils'),
    keyboard            : null,
    browserDetection    : require('core/gd/browser-detection'),
    ac: null,

    companyId: null,
    company: null,

    navigation: null,   // all navigation related methods
    appManager: null,   // all apps

    itemView: new ItemView(),   // main controller for item views

    // Apps
    app: null,

    // Layout
    layout: null, // link to ui-layout app
    modal: null, // link to ui-modal
    growl: null, //link to global-notifications

    // session: require('./session/session'), - poka ne uzaem gemora mnogo po hodu tam
    session: null,
    presence: null,

    bus     : new EventsBus(),
    modelBus: new ModelBus(),
    tree    : new CompaniesCollection(),

    api: Api,

    // core local settings handler...
    coreLocalSettings: null,

    curOrganizationId: null,
    organizationLock: false,

    taskView: new TaskView(),
    noteView: new NoteView(),

    attachments: new Attachments(),

    taskTimers: null,
    workSchedule: null,

    /**
     * Called right after main app receives session data
     */
    initOnSessionData: function() {
        this.ui         = createUI("left-nav")

        this.spaces     = new Spaces()
        this.databases  = new Databases() // is created here because it has gd usage in constructor

        gd.user         = gd.session.me

        this.skin       = new Skin()

    },

    initBeforeDataRequest: function() {

        this.session = new GDSession()

    },

    init: function() {

        // this.fields = new GlobalFields()

        this.coreLocalSettings = new LocalSettings("gd",{
            curOrganizationId: null,
            // ganttColumnsOrder: null,
            // projectGanttSort: null,
            // projectGanttWidth: null,
        });

        // this.initCurOrganizationId();

        // gd.user = gd.session.me;

        this.ac = new AccessControl();
        this.settings = new Settings();


        this.skin.init();
        this.session.init(); // we dont' really need it anymore

        this.presence = FakePresence; //new Presence();
        this.presence.init(); // zachem init tut ? :)

        // this.taskView.init();

        this.taskTimers = new TaskTimers();

        const MainRouter = gdConfig.routing;
        this.router = new MainRouter();


        this.navigation = new SharedNavigation();
        this.appManager = new AppManager();

        this.keyboard = new KeyboardShortcuts()
        this.keyboard.init();

        //this.taskTimers = new TaskTimers();

        //this.refreshTimer = new RefreshTimer();

        // workSchedule is created in SharedViewAppLoader because there is no companies data until shared view data load
        // this.workSchedule = new WorkSchedule();
    },

    start: function() {
        this.router.history.start({ pushState: true });
    },

    openEvent(event,eventName=null,eventType=null) {

        let eventId, name, type, eventFull;

        if (typeof event == "string") {
            eventId = event;
            name = eventName;
            type = eventType;
            eventFull = null;
        } else {
            eventId = event.id;
            name = event.name;
            type = event.eventType;
            eventFull = event;
        }

        gd.modals.event.viewById(eventId);
    },

    openNew(name=null,params={}) {

        if (debug) console.log(debug,"open New name=",name,"params:",params);

        // just new open click (no object specified -> open latest object)
        if (!name) {
            name = this.newTask.curObject;
        }

        // no project specifed but we are inside of a project
        if (!params.company && !params.projectId && gd.getApp() && gd.getApp().project && gd.getApp().project.role) {
            params.projectId = gd.getApp().project.id;
        }

        // "close all modals if open"
        gd.modal.hide();

        this.newTask.open2(name,params);
        this.layout.new.open();
    },

    getMainApp: function(){
        return this.app;
    },

    getApp: function(){
        const taskView = gd.itemView.findByContainerId(ITEM_VIEW_TASK);
        if (taskView) return taskView.app;

        if (this.app) return this.app;

        return false;
    },

    goTo: function(url, options) {
        if (debug) console.log(debug,"goTo",url,options);

        if (url == 'new-project') {
            gd.openNew('project');
            return;
        }

        if (url == 'new-user') {
            gd.openNew('user');
            return;
        }

        // real refresh.... used in delete organization
        if (options && options.reload) {
            document.location="/"+url;
            return false;
        }

        // if got to same url just restart
        if (window.location.pathname === "/" + url ){
            if (debug) console.log(debug," same URI - reStart APP",url);
            this.getApp().start();
        }

        // close new task if it's open...
        gd.layout.new.close();

        if (!options) options = {};
        options.trigger = true;

        this.router.navigate("#" + url, options);
    },

    setUrl(url, replace = true) {
        this.router.navigate(url, {
            trigger: false,
            replace: replace
        });
    },

    /*closeTaskView() {
        // close
        this.layout.task.close();

        // do something about the url
        if (this.app) this.setUrl(this.app.routerPath,true);
    },*/

    // This is a helper for navigating around the app.
    // this gets called by a global click handler that handles
    // all the <a> tags in the app.
    // it expects a url pathname for example: "/costello/settings"
    navigate: function(page) {
        var url = (page.charAt(0) === '/') ? page.slice(1) : page;
        this.router.history.navigate(url, {
            trigger: true
        });
    },


    // curOrganizationId

    /*getCurOrganizationId(forced=false) {

        if (this.session.companies.length<1) return null;

        // this is for future ???
        if (this.organizationLock) {
            if (!this.curOrganizationId) {
                console.error("error company lock but no company");
                this.setCurOrganizationId(this.session.companies.models[0].id);
            }
        }

        if (forced && !this.curOrganizationId) {
            // if (g)
            this.setCurOrganizationId(this.session.companies.models[0].id);
        }

        return this.curOrganizationId;
    },*/


    /*setCurOrganizationId: function(organizationId) {

        if (organizationId=='all') organizationId='';

        // recent organizations
        if (this.curOrganizationId!=organizationId) {
            gd.session.recent.organizations.increaseCounter(organizationId);
        }

        this.curOrganizationId = organizationId;
        this.coreLocalSettings.set('curOrganizationId',this.curOrganizationId);

        this.trigger('curOrganizationChanged');
    },*/

    initCurOrganizationId() {
        // const organizationId = this.coreLocalSettings.get('curOrganizationId');
        // if (organizationId) this.companyId = organizationId;
        // if (!this.companyId) this.companyId = this.session.companies.models[0].id;

        /*this.curOrganizationId = this.coreLocalSettings.get('curOrganizationId');
        if (!this.curOrganizationId && this.session.companies.length)
            this.curOrganizationId = this.getCurOrganizationId(true); // if no cur org in locStorage - use the very first one

        // if something is wrong (no logout, etc) reset to defualts !
        if (!this.session.companies.get(this.curOrganizationId)) {
            this.coreLocalSettings.resetToDefault();
            this.curOrganizationId = this.coreLocalSettings.get('curOrganizationId');
        }*/
    },

    setCompany(companyId) {

        debug && console.log(debug,"setCompany() companyId=", companyId)

        this.companyId = companyId;

        if (companyId && gd.session.companies.get(companyId)) {
            this.company = gd.session.companies.get(companyId)
            this.modules = new Modules(gd.company.settings._modulesConfig)
        }
    },

    apiError(error) {
        const errorMsg = (error && error.errorMessage) ? error.errorMessage : 'Oops, something went wrong. Refresh the page and try again';

        this.growl.error(errorMsg);
        // todo - log error somewhere...
        console.error("api call error",error);
    },

    /*isSingleOrganization() {
        return (!(gd.session.companies.length>1));
    }*/
});

module.exports = gd;
